import React from 'react';
import EditSubCategoryState from './editSubCategoryState/EditSubCategoryState';
import EditSubCategoryControlPanel from './components/EditSubCategoryControlPanel/EditSubCategoryControlPanel';
import Forms from './components/Forms/Forms';
import ModalWindows from './components/ModalWindows/ModalWindows';
// import style from './index.module.scss';

const EditSubCategoryPage: React.FC = () => {
	return (
		<EditSubCategoryState>
			<EditSubCategoryControlPanel />
			<Forms />
			<ModalWindows />
		</EditSubCategoryState>
	);
};

export default EditSubCategoryPage;
